import { Component } from '@angular/core';

@Component({
  selector: 'app-therapist-my-profile',
  templateUrl: './therapist-my-profile.component.html',
  styleUrls: ['./therapist-my-profile.component.sass'],
  standalone: false
})
export class TherapistMyProfileComponent {}
